import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { analytics } from "@heycatch/sdk";
import "@/index.css";
import App from "@/App";

analytics.init({
  projectKey: "hck_pk_xnqsNplO9kR0GcwpFjiaRzUE2LXsg7p1",
  install: {
    framework: "react",
    frameworkVersion: "19",
    agent: "e1",
  },
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
